import type { FanResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import {
  updateFanName,
  useChatDetails,
} from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { chatsService } from '@/modules/chatting/service/chats.ts'
import { useChattingTabs } from '@/modules/chatting/state/tabs-provider.ts'
import { handleError } from '@/utils/error'

interface Params {
  userId: FanResponseDto['id']
  onSuccess: (name: string) => void
}

export function useRenameUser({ onSuccess, userId }: Params) {
  const creatorId = useUnit($creatorId)
  const chat = useChatDetails(userId)
  const toast = useToast()
  const { setTabFanName } = useChattingTabs()
  const setNameMutation = useMutation(
    (name: string) =>
      chatsService.setDisplayName({ creatorId: creatorId!, userId, name }),
    {
      onSuccess: (_, name) => {
        updateFanName({ fanId: userId, name })
        // name could be `""` so need to set default name
        setTabFanName(userId, name || chat?.withUser.name || '')
        toast.success('User name was successfully updated')
        onSuccess(name)
      },
      onError: (error) => {
        handleError(
          error,
          'Unexpected error occurred while setting name, please try again later',
        )
      },
    },
  )

  return setNameMutation.mutateAsync
}
